import { timezones } from 'constants/timezones';
import { formatTimezoneWithOffset } from 'utils';

interface TimezoneOption {
  label: string;
  value: string;
}

/**
 * Maps a tz to a TimezoneOption
 */
function tzToOption(tz: string): TimezoneOption | null {
  const label = formatTimezoneWithOffset(tz);
  if (!label) return null;
  return {
    label,
    value: tz,
  };
}

export const timezoneOptions = timezones.reduce((tzOptions, timezone) => {
  const tzOption = tzToOption(timezone);
  if (tzOption) {
    tzOptions.push(tzToOption(timezone));
  }
  return tzOptions;
}, []);
